import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=b222f7dc&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-webs-hongkong-buff-tec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b222f7dc"]])

export default __exports__